import React, { useState } from 'react';
import { BsListTask, BsWallet2 } from 'react-icons/bs';
import { SiGooglesheets, SiJira, SiClickup } from 'react-icons/si';
import './Configurations.css';

const TABS = [
  { id: 'task-organizer', label: 'Task Organizer', Icon: BsListTask },
  { id: 'finance-organizer', label: 'Finance Organizer', Icon: BsWallet2 },
];

function Configurations() {
  const [activeTab, setActiveTab] = useState('task-organizer');

  return (
    <div className="configurations-page">
      <h2 className="configurations-title">Configurations</h2>
      <p className="configurations-subtitle">Integrate with your favorite channels.</p>

      <div className="configurations-tabs-wrapper">
        <div className="configurations-tabs" role="tablist">
          {TABS.map(function (tab) {
            const isActive = activeTab === tab.id;
            const IconComponent = tab.Icon;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={'configurations-tab' + (isActive ? ' configurations-tab--active' : '')}
                onClick={function () {
                  setActiveTab(tab.id);
                }}
              >
                {IconComponent && (
                  <span className="configurations-tab-icon">
                    <IconComponent size={18} />
                  </span>
                )}
                {tab.label}
              </button>
            );
          })}
        </div>
        <div className="configurations-tab-content">
          {activeTab === 'task-organizer' && (
            <div className="configurations-task-organizer">
              <div className="configurations-integration-grid">
                <div className="configurations-integration-item">
                  <span className="configurations-integration-icon configurations-integration-icon--sheets">
                    <SiGooglesheets size={32} />
                  </span>
                  <span className="configurations-integration-label">Google Sheets</span>
                  <button type="button" className="configurations-integrate-btn">Integrate</button>
                </div>
                <div className="configurations-integration-item">
                  <span className="configurations-integration-icon configurations-integration-icon--jira">
                    <SiJira size={32} />
                  </span>
                  <span className="configurations-integration-label">Jira</span>
                  <button type="button" className="configurations-integrate-btn">Integrate</button>
                </div>
                <div className="configurations-integration-item">
                  <span className="configurations-integration-icon configurations-integration-icon--clickup">
                    <SiClickup size={32} />
                  </span>
                  <span className="configurations-integration-label">ClickUp</span>
                  <button type="button" className="configurations-integrate-btn">Integrate</button>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'finance-organizer' && (
            <p className="configurations-pane-text">Content of Finance Organizer</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Configurations;
